<template>
  <div class="cart">
    <PageHeader title="Marketplace"></PageHeader>
    <Cart v-if="supplierByShopId"
          :cart="cartBySupplier"
          :suppliers="supplierByShopId"
          :shopId="shopId"
          @deleteOneProduct="rmvProductFromCart($event)"
          @removeAllProducts="clearCart"
          @validateCart="clearCart"
          @bubbleUpDate="fetchDate($event)"
          @bubbleUpSupplier="specificSupplierOrderProcess($event)"
          v-loading.fullscreen.lock="loading"></Cart>
    <Franco :orderConstraint="orderConstraint"
            :isVisible="isVisible"
            @closedFranco="closeFranco"></Franco>
  </div>
</template>

<script>
  import _ from 'lodash';
  import services from 'services';
  import Cart from '@/components/Cart/Cart.vue';
  import Franco from '@/components/Franco/Franco.vue';
  import PageHeader from '../../../components/PageHeader/PageHeader.vue';
  import HistoryService from '../../../services/server/history-service/HistoryService';
  import { basicUtils, csvUtils, jobUtils } from '../../../utils/utils';

  export default {
    components: {
      Cart,
      Franco,
      PageHeader,
    },
    data() {
      return {
        cmdNumber: null,
        loading: false,
        desirableDate: [],
        date: '',
        isVisible: false,
        orderConstraint: {},
      };
    },
    computed: {
      cart() {
        return this.$store.getters['cart/cart'];
      },
      cartOrder() {
        return this.$store.getters['cart/cartOrder'];
      },
      cartBySupplier() {
        return this.$store.getters['cart/cartBySupplier'];
      },
      cartBySupplierArray() {
        return services.CartService.cartBySupplierToArray(this.$store.getters['cart/cartBySupplier']);
      },
      totalPriceHt() {
        return this.$store.getters['cart/cartTotalSumHt'];
      },
      supplierByShopId() {
        return this.$store.getters['supplier/suppliersByShopId'];
      },
      shopId() {
        return this.$store.getters['shopAuth/currentShopId'];
      },
      shopEmail() {
        return this.$store.getters['shopAuth/currentShop'].shopEmail;
      },
      shopName() {
        return this.$store.getters['shopAuth/currentShopInfo'].name;
      },
      shopContactPoint() {
        return this.$store.getters['shopAuth/currentShopInfo'].contactPoint;
      },
      shopCountOrder() {
        return this.$store.getters['shopAuth/currentShopInfo'].countOrder;
      },
    },
    methods: {
      closeFranco() {
        this.isVisible = false;
      },
      fetchDate(data) {
        const isHere = this.desirableDate.findIndex((el) => data.supplier === el.supplier);
        if (isHere !== -1) {
          this.desirableDate[isHere].date = data.date;
          return;
        }
        this.desirableDate.push(data);
      },
      clearCart() {
        this.$store.dispatch('cart/clearCart');
      },
      getContactPointBySupplier(supplier) {
        return _.get(this.shopContactPoint, supplier);
      },
      rmvProductFromCart(product) {
        this.$store.dispatch('cart/removeOneProductFromCart', product);
      },
      getOrderType(supplierName) {
        return this.supplierByShopId.find((supplier) => supplier.name === supplierName).orderType;
      },
      updateCounter() {
        services.EdiService.incrementsOrderCounter(this.shopId, this.shopCountOrder + 1)
          .then(() => {
            this.$store.dispatch('shopAuth/getShopInfo', this.shopId);
          });
      },

      checkRequiredDate() {
        const supplierMissing = [];
        this.cartBySupplierArray.forEach((supplier) => {
          const isDateEveryWhere = this.desirableDate.find((el) => el.supplier === supplier.key);
          if (!isDateEveryWhere) {
            supplierMissing.push(supplier.key);
          }
        });
        if (supplierMissing.length) {
          supplierMissing.forEach((el) => {
            this.$message.error({
              type: 'error',
              message: `Entrez une date de livraison souhaitée pour ${el}`,
            });
          });
        }
        return supplierMissing;
      },

      async sendEdifact(supplier, date) {
        const noOrder = jobUtils.generateOrderNumber(this.shopId, '2', this.shopCountOrder);
        this.cmdNumber = noOrder;
        const orderType = this.getOrderType(supplier.key);

        const history = HistoryService.historyFromCart(
          supplier.value,
          this.shopId,
          this.$store.getters['auth/currentUser'].user.name,
          this.totalPriceHt,
          supplier.key,
          noOrder,
          this.getOrderType(supplier.key),
        );
        const cmdId = await HistoryService.putHistory(history);
        const res = await services.EdiService.sendEdifactOrder(
          services.CartService.ediPostBody(
            supplier.value,
            this.shopId,
            noOrder,
            cmdId,
            orderType,
            date.date,
            supplier.key,
          ),
        );
        // test uri
        if (res.status === 200) {
          await HistoryService.updateHistoryStatus(noOrder, 'créé');
          this.showEdiSuccessMessage(supplier.key);
          this.loading = false;
          this.$router.push({ name: 'History' });
        } else {
          await HistoryService.updateHistoryStatus(noOrder, 'Une erreur est survenue');
          this.loading = false;
          this.$router.push({ name: 'History' });
          this.$mixpanel.track('Erreur Edi', {
            app: process.env.VUE_APP_NAME,
          });
          this.showErrorMessage(supplier.key);
        }
      },

      async specificSupplierOrderProcess(supplier) {
        const orderConstraint = this.supplierByShopId.find((s) => s.name === supplier.key)
          .order_constraint;
        // eslint-disable-next-line max-len
        const constraints = services.SupplierService
          .isConstraintsRespected(supplier, orderConstraint, this.totalPriceHt);
        if (!_.isEmpty(constraints)) {
          this.orderConstraint = constraints;
          this.isVisible = true;
          return;
        }
        let choosenDate = '';
        if (services.CartService.getSupplierDisplayDate(supplier.key)) {
          choosenDate = this.desirableDate.find((el) => el.supplier === supplier.key);
          if (!choosenDate) {
            this.$message.error({
              type: 'error',
              message: `Entrez une date de livraison souhaitée pour ${supplier.key}`,
            });
            return;
          }
        }
        if (this.getOrderType(supplier.key) === 'MAILLING') {
          this.loading = true;
          await this.sendMail(supplier, choosenDate);
          this.loading = false;
        } else if (this.getOrderType(supplier.key) === 'EDI') {
          this.loading = true;
          await this.sendEdifact(supplier, choosenDate);
          await this.sendMail(supplier, choosenDate);
          await this.$store.dispatch('cart/removeOneSupplierFromCart', supplier.key);
        }
        await this.$store.dispatch('cart/removeOneSupplierFromCart', supplier.key);
        this.$router.push({ name: 'History' });
        this.$mixpanel.track('redirection vers l\'historique', {
          app_mb: process.env.VUE_APP_NAME,
        });
      },
      async sendMail(supplier, choosenDate) {
        let noOrder = null;
        if (!this.cmdNumber) {
          noOrder = jobUtils.generateOrderNumber(this.shopId, '2', this.shopCountOrder);
        } else {
          noOrder = this.cmdNumber;
        }
        const mailRecipient = this.getContactPointBySupplier(supplier.key);
        const mailSender = this.shopEmail;
        const checks = [
          process.env.VUE_APP_MAIL_ARTHUR,
          process.env.VUE_APP_MAIL_LUDO,
        ];
        const body = {
          no_order: noOrder,
          bakery: this.shopName,
          date: choosenDate.date,
        };

        const history = HistoryService.historyFromCart(
          supplier.value,
          this.shopId,
          this.$store.getters['auth/currentUser'].user.name,
          this.totalPriceHt,
          supplier.key,
          noOrder,
          this.getOrderType(supplier.key),
        );
        const csvArray = supplier.value.map((product) => ({
          Num_cmde: noOrder,
          Ref_Blachere: product.id,
          Ref_Fournisseur: product.ref,
          Nom: product.name,
          Quantite: product.quantity,
          Unite_achat: product.uc,
          Unite_conditionement: product.uc,
          Fournisseur: product.supplier,
          Prix_unitaire: product.prix,
          EAN: product.ean,
        }));
        // eslint-disable-next-line no-param-reassign
        if (supplier.key !== 'AGIDRA') {
          csvArray[0].no_magasin = this.shopId;
        }
        if (supplier.key === 'AGIDRA') {
          csvArray[0].no_magasin = await services.CartService.getAgidraShopId(this.shopId);
        }
        // eslint-disable-next-line no-param-reassign
        csvArray[0].Code_GLN_magasin = '';
        // eslint-disable-next-line no-param-reassign
        csvArray[0].nom_magasin = this.$store.getters['shopAuth/shopName'];
        // eslint-disable-next-line no-param-reassign
        csvArray[0].Date_commande = basicUtils.currentDate();
        // eslint-disable-next-line no-param-reassign
        csvArray[0].date_livraison = choosenDate.date;
        // eslint-disable-next-line no-param-reassign
        // csvArray[0].adresse_magasin = await services
        //   .ShopInfoService
        //   .getShopAddrFromPOS(this.shopId);

        const csv = csvUtils.jsonToCsv(csvArray);
        // await services.PdfService.pdfGenerator(supplier.value);

        await services.MailingService.sendEmail(
          mailRecipient,
          mailSender,
          body,
          csv,
          history,
        );
        try {
          services.MailingService.checkSentMail(checks, mailSender, history)
            .then(() => {
              this.loading = false;
            });
        } catch (e) {
          console.log(e);
          this.loading = false;
        }
        this.$mixpanel.track('Envoi des mail de callback', {
          app_mb: process.env.VUE_APP_NAME,
        });
        await HistoryService.putHistory(history);
        this.showMaillingSuccessMessage(supplier.key);
      },

      showMaillingSuccessMessage(supplier) {
        try {
          this.updateCounter();
          this.$message({
            type: 'success',
            message: `${this.$t('cart.send')} à ${supplier} 🚀🚀`,
          });
        } catch (e) {
          this.$message({
            type: 'success',
            message: `Mail envoyé à ${supplier} 🚀`,
          });
        }
      },
      showEdiSuccessMessage(supplier) {
        try {
          this.$message({
            type: 'message',
            message: `Commande transmise à ${supplier} 🚀🚀`,
          });
        } catch (e) {
          this.$message({
            type: 'success',
            message: `Mail envoyé à ${supplier} 🚀`,
          });
        }
      },
      showErrorMessage(supplier) {
        this.$message.error({
          type: 'error',
          message: `Echec du passage de commande à ${supplier}`,
        });
      },
    },
  };
</script>

<style lang="stylus">
  @import '~@/assets/css/main.styl';

</style>
